import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { typographyFontSizeCfg } from 'ds/components/typography/types';

export const BannerRoot = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(2)};
  `}
`;

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.neutrals.grey1};
  color: ${({ theme }) => theme.colors.neutrals.white};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: ${({ theme }) => theme.spacing(2, 2.5)};
  gap: ${({ theme }) => theme.spacing(2)};
  position: relative;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    min-width: 370px;
  `}
`;

export const LeftSection = styled.div<{ clickable: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
  margin: -${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  > svg path {
    fill: ${({ theme }) => theme.colors.neutrals.white};
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Subtitle = styled(Text)`
  font-size: ${typographyFontSizeCfg.textLabel.small}px;
  line-height: normal;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
